export default __webpack_public_path__ + "static/headstand-variations-1-84bbcdabfd146ce9d65f5c6e207ca620.jpg";